import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
// @mui
import { Box } from '@mui/material';
// hooks
// import useResponsive from '../../hooks/useResponsive';
// components
// import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import AdminHeader from './header';
import AdminNavbar from './nav/AdminNavbar';
import { NAV } from '../../config-global';
// ----------------------------------------------------------------------------------------------

export default function AdminLayout() {

    //   const { themeLayout } = useSettingsContext();
    //   const isDesktop = useResponsive('up', 'lg');
    const IsFullScreen = useSelector(state => state.screen.fullScreenVale);
    const [open, setOpen] = useState(false);
    const [navWidth, setNavWidth] = useState(NAV.W_DASHBOARD);

    const handleOpen = () => {
        setOpen(true);
        setNavWidth(NAV.W_DASHBOARD);
    };

    const handleClose = () => {
        setOpen(false);
        setNavWidth(0);
    };

    //   const renderNavVertical = <JJMINavbar openNav={open} onCloseNav={handleClose} />;

    return (
        <>
            {!IsFullScreen && <AdminHeader openNav={open} onOpenNav={handleOpen} navWidth={navWidth} />}

            <Box
                sx={{
                    display: { lg: 'flex' },
                    minHeight: { lg: 1 },
                }}
            >
                <AdminNavbar openNav={open} onOpenNav={handleOpen} onCloseNav={handleClose} navWidth={navWidth} />

                <Main>
                    <Outlet />
                </Main>
            </Box>
        </>
    );
}
